import React from 'react';

import './payRulesQualifiers.scss';
import { useGetPayQualifiersQuery } from './payRulesQualifiersSlice';

interface propTypes {
    inputMonth: number;
    inputYear: number;
    inputScorecardVersion: number;
    inputEmployeeNumber?: number;
}
export const PayRulesQualifiers = ({ inputMonth, inputYear, inputScorecardVersion, inputEmployeeNumber }: propTypes) => {
    const { data: payQualifiersData } = useGetPayQualifiersQuery(
        {
            year: inputYear,
            month: inputMonth,
            scorecardVersionId: inputScorecardVersion,
            employeeNumber: inputEmployeeNumber,
        },
        { skip: !inputYear || !inputMonth || !inputScorecardVersion || !inputEmployeeNumber }
    );
    return (
        <div className="card my-4 borderRadius10">
            <div className="card-body">
                <h6 className="card-title">Qualifiers</h6>
                {payQualifiersData?.data.length > 0 ? (
                    payQualifiersData?.data.map((item: any, index: any) =>
                        <div key={index}>
                            <div className="row mt-4">
                                <div className="col-md-12 pe-0 me-0" >
                                    <strong>{item.pay_qualifier_type_name}</strong>
                                </div>
                            </div>
                            <div className="row mt-4">
                                <div className="col-md-12">
                                    <div className="col-md-6 normalFont pe-0">{item.pay_qualifier_operator}{item.metric_value} {item.pay_qualifier_type_name === 'Worked Hours' ? ' hrs' : ''}</div>
                                </div>
                            </div>
                        </div>
                    )) : 'No results found.'
                }
            </div>
        </div >
    );
};